'use client'

import { HomepageBlocksModel } from '@marketplace-web/home/home-page-data'

import BlocksFetcher from '../BlocksFetcher'
import HomeBlocks from '../HomeBlocks'
import { useHomeContext } from '../HomeProvider'
import HomeLoader from '../common/HomeLoader'
import useFetchHomepageBlocks from '../hooks/useFetchHomepageBlocksNew'
import HomeSkeleton from '../common/HomeSkeleton'

type Props = {
  initialData: HomepageBlocksModel
}

const HomeContent = ({ initialData }: Props) => {
  const { isLoading } = useHomeContext()
  const { blocks, areBlocksLoading, fetchMoreBlocks } = useFetchHomepageBlocks({ initialData })

  const hasNextPage = !!blocks?.nextPageToken
  const showLoader = (hasNextPage && !blocks?.showLoadMoreButton) || areBlocksLoading

  if (isLoading) {
    return <HomeSkeleton />
  }

  return (
    <>
      {/* TODO move children to `HomeContent` folder */}
      {blocks && <HomeBlocks blocks={blocks} />}
      {hasNextPage && !areBlocksLoading && (
        <BlocksFetcher
          fetchMoreBlocks={fetchMoreBlocks}
          showLoadMoreButton={blocks.showLoadMoreButton}
        />
      )}
      {showLoader && <HomeLoader />}
    </>
  )
}

export default HomeContent
